import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const Alert = styled.div`
  display: flex;
  padding: ${theme.spacing['spacing-5']} ${theme.spacing['spacing-6']}
    ${theme.spacing['spacing-5']} ${theme.spacing['spacing-6']};
  border-radius: ${theme.borderRadius['border-radius-3']};
  ${(props) => getVariant(props)}
`;

export const AlertTitle = styled.div`
  margin-bottom: ${theme.spacing['spacing-1']};
`;

export const IconBaseAlert = styled.div``;

export const TextWrapper = styled.div`
  margin-left: ${theme.spacing['spacing-3']};
`;

export const LinkAlert = styled.div`
  margin-top: ${theme.spacing['spacing-3']};
`;

const getVariant = (props) => {
  return css`
    background-color: ${theme.colors[props.variant].bg.weak};
  `;
};
